import { PropsWithChildren } from 'react';
import styled from 'styled-components'

const Picker = styled.div`
	margin: 30px 0 0;
`;

const InfoText = styled.h4`
	margin: 0 0 25px;
	font-weight: 500;
	font-size: 0.9rem;
`;

const Options = styled.div`
	display: flex;
	flex-flow: row wrap;
	margin: 0 -15px;
	justify-content: center;
`;

const LayoutPicker = (props: PropsWithChildren<{}>) => {
	return (
		<Picker>
			<InfoText>Select a contribution type and see preview.</InfoText>
			<Options>
				{props.children}
			</Options>
		</Picker>
	)
}

export default LayoutPicker;
